import { Box, Chip } from '@mui/material';
import { memo, useMemo } from 'react';
import { useFiltersContext } from './contexts/filtersContext';
import { useSavedFilterContext } from './contexts/savedFiltersContext';

export const SavedFilterChips = memo(() => {
  const { savedFilters, filterChips } = useSavedFilterContext();
  const { form } = useFiltersContext();
  const allFilters = useMemo(() => {
    return [...Object.values(savedFilters.value), ...Object.values(savedFilters.orgValue)];
  }, [savedFilters.orgValue, savedFilters.value]);

  if (!filterChips.isShown) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex', gap: 1, marginTop: 2 }}>
      {allFilters.map((filter) => {
        const isActive = savedFilters.activeSavedFilterId === filter.id;
        return (
          <Chip
            size='small'
            key={filter.id}
            label={filter.name}
            color={isActive ? 'primary' : 'default'}
            onClick={() => {
              savedFilters.setActiveSavedFilter(isActive ? undefined : filter.id);
              if (isActive) {
                const [, setValues] = form.values;
                setValues({});
              }
            }}
          />
        );
      })}
    </Box>
  );
});
